import React from 'react';
import { motion } from 'framer-motion';
export function UpsellSection() {
  const comparisonRows = [{
    situation: 'Te rechazaron un crédito injustamente',
    without: 'Te resignás y seguís esperando',
    with: 'Reclamás el daño moral formalmente'
  }, {
    situation: 'Estudios de cobranza te acosan',
    without: 'Bloqueás el número y rezás',
    with: 'Documentás el acoso como evidencia legal'
  }, {
    situation: 'Tu scoring está destruido',
    without: 'No sabés cuánto perdiste',
    with: 'Calculás el lucro cesante exacto'
  }, {
    situation: 'Querés avanzar legalmente',
    without: 'Pagás un abogado carísimo',
    with: 'Estrategia de litigio low-cost incluida'
  }, {
    situation: 'Datos negativos siguen apareciendo',
    without: 'Esperás que desaparezcan solos',
    with: 'Expediente completo para escalar'
  }];
  const kitIncludes = ['Monetización del Daño Moral', 'Cazador de Estudios de Cobranza', 'Peritaje de Scoring', 'Estrategia Litigio Low-Cost', 'Calculadora de Lucro Cesante', 'Modelos de Demanda'];
  return <section className="w-full py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #050504 0%, #0d0b08 50%, #050504 100%)'
  }} data-id="element-320">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.04] pointer-events-none" style={{
      background: 'radial-gradient(circle, #C9A84C 0%, transparent 70%)'
    }} data-id="element-321" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center relative z-10" data-id="element-322">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-323">
          <div className="text-brand-gold text-xs font-bold tracking-[0.3em] uppercase mb-4" data-id="element-324">
            UPGRADE EXCLUSIVO
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-325">
            ¿Qué agrega la{' '}
            <span className="text-brand-gold" data-id="element-326">Operación Retribución</span>?
          </h2>
          <p className="text-gray-500 mt-3 text-sm sm:text-base max-w-xl mx-auto" data-id="element-327">
            Pasá de limpiar tu historial a reclamar lo que te deben.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full rounded-2xl overflow-hidden mb-20 shadow-[0_0_40px_rgba(201,168,76,0.04)]" style={{
        border: '1px solid rgba(201, 168, 76, 0.15)',
        background: 'linear-gradient(180deg, #0d0b08 0%, #080808 100%)'
      }} data-id="element-328">
          <div className="grid grid-cols-3" style={{
          background: 'linear-gradient(90deg, #0d0b08 0%, #12100a 50%, #0d0b08 100%)',
          borderBottom: '1px solid rgba(201, 168, 76, 0.15)'
        }} data-id="element-329">
            <div className="p-5 sm:p-6 font-bold text-white/80 text-xs sm:text-sm uppercase tracking-wider" data-id="element-330">
              Situación
            </div>
            <div className="p-5 sm:p-6 font-bold text-red-400/90 sm:text-sm uppercase tracking-wider flex gap-2 border-l border-white/5 text-[11px] flex-row items-center justify-center" data-id="element-331">
              <span className="text-red-500" data-id="element-332">✕</span> Sin Retribución
            </div>
            <div className="p-5 sm:p-6 font-bold text-brand-gold sm:text-sm uppercase tracking-wider flex gap-2 border-l border-white/5 text-[11px] items-center justify-center" data-id="element-333">
              <span className="text-brand-gold" data-id="element-334">✓</span> Con Retribución
            </div>
          </div>

          {comparisonRows.map((row, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="grid grid-cols-3 group transition-colors duration-200 hover:bg-brand-gold/[0.02]" style={{
          borderBottom: index < comparisonRows.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
          background: index % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)'
        }} data-id="element-335">
              <div className="p-5 sm:p-6 text-gray-300 text-sm sm:text-base flex items-center leading-relaxed" data-id="element-336">
                {row.situation}
              </div>
              <div className="p-5 sm:p-6 text-gray-500 text-sm sm:text-base flex items-center border-l border-white/5 leading-relaxed" data-id="element-337">
                {row.without}
              </div>
              <div className="p-5 sm:p-6 text-white font-medium text-sm sm:text-base flex items-center border-l border-white/5 leading-relaxed" data-id="element-338">
                {row.with}
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full flex flex-col items-center" data-id="element-339">
          <div className="flex items-center gap-3 mb-10" data-id="element-340">
            <div className="h-px w-12 bg-brand-gold/30" data-id="element-341" />
            <h3 className="text-lg sm:text-xl font-bold text-white uppercase tracking-wider flex items-center gap-2" data-id="element-342">
              <span className="text-brand-gold" data-id="element-343">✅</span> El kit incluye
            </h3>
            <div className="h-px w-12 bg-brand-gold/30" data-id="element-344" />
          </div>

          <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5 max-w-3xl" data-id="element-345">
            {kitIncludes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.3
          }} className="border border-brand-gold/25 bg-[#0a0a0a] rounded-full px-3.5 py-1.5 text-xs text-gray-200 font-medium shadow-[0_0_15px_rgba(201,168,76,0.04)] hover:border-brand-gold/50 hover:shadow-[0_0_20px_rgba(201,168,76,0.08)] transition-all duration-300" data-id="element-346">
                {item}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}